import './style.css';

const htmlIsBuilt = new Event("pbc:tab_html_built", { bubbles: true })
const API_URL = '/a/pbc/tab-settings/';

const iconMinus = '<svg width="19" height="3" viewBox="0 0 19 3" xmlns="http://www.w3.org/2000/svg">\n' +
  '    <path d="M17 1.5L2 1.5"  stroke-width="3" stroke-linecap="round"/>\n' +
  '</svg>'

const iconPlus = '<svg width="19" height="19" viewBox="0 0 19 19"\n' +
  '                       xmlns="http://www.w3.org/2000/svg">\n' +
  '                    <path d="M9.5 2V17"  stroke-width="3" stroke-linecap="round"/>\n' +
  '                    <path d="M17 9.5L2 9.5"  stroke-width="3" stroke-linecap="round"/>\n' +
  '                  </svg>'
const chevronDown = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="19" height="19">\n' +
  '                    <path \n' +
  '                          d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/>\n' +
  '                  </svg>'
const chevronUp = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="19" height="19">\n' +
  '                    <path \n' +
  '                          d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"/>\n' +
  '                  </svg>'

let tabs = [];

window.pbcTabWidget = {
  init: async () => {
    if (tabs.length > 0) {
      for (let i = 0; i < tabs.length; i++) {
        try {
          const config = await window.pbcTabWidget.getTabConfig(tabs[i].productId)

          tabs[i].config = config.data;

          window.pbcTabWidget.loadTabWidget(tabs[i]);
        } catch (error) {
          console.log(error)
        };
      }
    }
  },
  extractVideoUrl: (url) => {
    let videoEmbedUrl = '';

    try {
      let urlObj = new URL(url);

      if (urlObj.hostname.includes('cdn.shopify.com') || urlObj.hostname.includes('shopify')) {
        videoEmbedUrl = url;
      } else {
        switch (urlObj.hostname) {
          case 'youtu.be':
            videoEmbedUrl = `https://www.youtube.com/embed${urlObj.pathname}`;
            break;
          case 'www.youtube.com':
            let searchParams = new URLSearchParams(urlObj.search);
            if (searchParams.has('v')) {
              videoEmbedUrl = `https://www.youtube.com/embed/${searchParams.get('v')}`;
            }
            break;
          case 'vimeo.com':
            videoEmbedUrl = `https://player.vimeo.com/video${urlObj.pathname}`;
            break;
          default:
            videoEmbedUrl = url;
        }
      }
    } catch (error) {
      console.error("Error extracting video URL:", error);
    }

    return videoEmbedUrl;
  },
  getTabConfig: (productId) => {
    let tabDataFromMetafield = document.querySelectorAll('.pbc-tab-widget[data-product-id="' + productId + '"] > #pbc-tab-data');
    if (tabDataFromMetafield.length > 0) {
      console.log("Using data from metafield")
      return new Promise((resolve, reject) => {
        resolve({
          data: JSON.parse(tabDataFromMetafield[0].innerHTML).Item || {}
        })
      })
    }

    return fetch(API_URL + productId + '?url=' + window.location.href).then(data => data.json())
  },
  loadTabWidget: (tabData) => {
    window.pbcTabWidget.appendStyleVariables(tabData);

    if (tabData.config.tabType?.value === 'description') {
      tabData.config.tabs = window.pbcTabWidget.parseTabsDescriptions(tabData);
      if (tabData.config.tabs.length === 0) { //We didn't parse any tabs. Rendering description
        window.pbcTabWidget.renderRegularDescription(tabData.wrapper);
        return
      }
      let wrapper = tabData.wrapper
      let productDescription = wrapper.querySelector('#pbc-description').innerHTML;
      let splittingTag = tabData.config.descriptionTag?.value;
      let titlesRegex = new RegExp(`<${splittingTag}.*?>(.*?)<\/${splittingTag}`, 'g')
      let contentsRegex = new RegExp(`\/${splittingTag}>((.|\n)*?)(<${splittingTag}|$)`, 'g')

      let titles = Array.from(productDescription.matchAll(titlesRegex))
      let contents = Array.from(productDescription.matchAll(contentsRegex))

      tabData.config.tabs = titles.map((title, index) => {
        return {title: title[1], contentText: contents[index][1].trim()}
      })
    }

    if (tabData.config.tabStyle?.value === 'accordion') {
      window.pbcTabWidget.renderAccordions(tabData.config, tabData.wrapper);
      window.pbcTabWidget.initAccordionListeners(tabData.config.iconType?.value, tabData.wrapper);
    } else {
      window.pbcTabWidget.renderTabs(tabData.config, tabData.wrapper);
      window.pbcTabWidget.initTabListeners(tabData.wrapper);
    }

    document.dispatchEvent(htmlIsBuilt);
  },
  parseTabsDescriptions: (tabData) => {
    const description = document.getElementById('pbc-description').textContent;
    const splittingTag = tabData.config.descriptionTag
    let titlesRegex = new RegExp(`<${splittingTag?.value}.*?>(.*?)<\/${splittingTag?.value}`, 'gs')
    let contentsRegex = new RegExp(`\/${splittingTag?.value}>((.|\n)*?)(<${splittingTag?.value}|$)`, 'gs')
    const titles = Array.from(description.matchAll(titlesRegex))
    const contents = Array.from(description.matchAll(contentsRegex))

    return titles.map((title, index) => {
      return {
        title: title[1],
        contentText: contents[index][1].trim(),
        orderPosition: index,
        contentType: { value: 'text', label: "Text" }
      }
    })

  },

  renderMetafieldValue: (metafieldType, metafieldValue) => {
    let renderedValue = '';

    switch (metafieldType) {
      case 'single_line_text_field':
        renderedValue = `<p>${metafieldValue}</p>`;
        break;
      case 'multi_line_text_field':
        renderedValue = `<p>${metafieldValue.replaceAll('\n', '<br>')}</p>`;
        break;
      case 'number_integer':
        renderedValue = `<p>${parseInt(metafieldValue)}</p>`;
        break;
      case 'number_decimal':
        renderedValue = `<p>${parseFloat(metafieldValue).toFixed(2)}</p>`;
        break;
      case 'date':
        renderedValue = `<p>${new Date(metafieldValue).toDateString()}</p>`;
        break;
      case 'date_time':
        renderedValue = `<p>${new Date(metafieldValue).toLocaleString()}</p>`;
        break;
      case 'boolean':
        renderedValue = `<p>${metafieldValue ? 'Yes' : 'No'}</p>`;
        break;
      default:
        renderedValue = `<p>${metafieldValue}</p>`;
    }

    return renderedValue;
  },
  appendStyleVariables: (tabData) => {
    let rootStyles = '';
    rootStyles += ':root{\n';

    rootStyles += '--pbcTabs-tab-border-color: ' + tabData.config.borderColor + ';\n';
    rootStyles += '--pbcTabs-tab-heading-border-color: ' + tabData.config.borderColor + '66;\n';
    rootStyles += '--pbcTabs-tab-icon-color: ' + tabData.config.iconColor + ';\n';
    rootStyles += '--pbcTabs-active-tab-border-color: ' + tabData.config.activeTabBorderColor + ';\n';

    rootStyles += '--pbcTabs-header-font-size: ' + Number(tabData.config.headingFontSize) + 'px;\n';
    rootStyles += '--pbcTabs-header-background-color: ' + tabData.config.headerBackground + ';\n';
    rootStyles += '--pbcTabs-active-header-background-color: ' + tabData.config.activeHeaderBackground + ';\n';
    rootStyles += '--pbcTabs-header-color: ' + tabData.config.headerColor + ';\n';
    rootStyles += '--pbcTabs-active-header-color: ' + tabData.config.activeHeaderColor + ';\n';
    rootStyles += '--pbcTabs-header-padding-top: ' + Number(tabData.config.headingPaddingTop) + 'px;\n';
    rootStyles += '--pbcTabs-header-padding-bottom: ' + Number(tabData.config.headingPaddingBottom) + 'px;\n';
    rootStyles += '--pbcTabs-header-padding-left: ' + Number(tabData.config.headingPaddingLeft) + 'px;\n';
    rootStyles += '--pbcTabs-header-padding-right: ' + Number(tabData.config.headingPaddingRight) + 'px;\n';

    rootStyles += '--pbcTabs-content-font-size: ' + Number(tabData.config.contentFontSize) + 'px;\n';
    rootStyles += '--pbcTabs-content-background-color: ' + tabData.config.contentBackground + ';\n';
    rootStyles += '--pbcTabs-content-color: ' + tabData.config.contentColor + ';\n';
    rootStyles += '--pbcTabs-content-padding-top: ' + Number(tabData.config.contentPaddingTop) + 'px;\n';
    rootStyles += '--pbcTabs-content-padding-bottom: ' + Number(tabData.config.contentPaddingBottom) + 'px;\n';
    rootStyles += '--pbcTabs-content-padding-left: ' + Number(tabData.config.contentPaddingLeft) + 'px;\n';
    rootStyles += '--pbcTabs-content-padding-right: ' + Number(tabData.config.contentPaddingRight) + 'px;\n';

    rootStyles += '--pbcTabs-header-font-weight: ' + tabData.config.headerFontWeight?.value + ';\n';
    rootStyles += '--pbcTabs-active-header-font-weight: ' + tabData.config.activeHeaderFontWeight?.value + ';\n';
    rootStyles += '--pbcTabs-header-text-transform: ' + (tabData.config.textTransform ? tabData.config.textTransform?.value : 'none') + ';\n';

    rootStyles += '}';

    let styleVariables = document.createElement('style');
    styleVariables.id = 'pbcCssVariables';
    styleVariables.textContent = rootStyles;

    let globalStyles = document.createElement('link');
    globalStyles.rel = 'stylesheet';
    globalStyles.href = 'https://producttabs.polarbearapps.com/frontend/style.css';

    if (process.env.ENVIRONMENT === 'dev') {
      globalStyles.href = 'https://producttabs/frontend/style.css';
    } else if (process.env.ENVIRONMENT === 'stage') {
      globalStyles.href = 'https://producttabs-staging.polarbearapps.com/frontend/style.css';
    }


    document.getElementsByTagName('head')[0].appendChild(styleVariables);
    document.getElementById('pbcCssVariables').after(globalStyles);
  },
  renderTabs: (tabData, wrapper) => {
    let tabHeadings = document.createElement('div');
    let tabContents = document.createElement('div');

    tabHeadings.className = 'pbc-tab-headings';
    tabHeadings.role = 'tablist';

    tabContents.className = 'pbc-tab-contents';
    tabContents.classList.add('pbc-content')

    tabData.tabs?.forEach((tab, index) => {
      let tabHeading = document.createElement('button');
      let tabTitle = document.createElement('span');

      tabHeading.className = 'pbc-tab-heading'
      tabHeading.type = 'button'
      tabHeading.role = 'tab'
      tabHeading.id = 'tab-trigger-' + index
      tabHeading.ariaSelected = 'false'
      tabHeading.setAttribute('aria-controls', 'tab-panel-' + index)

      if (index === 0) {
        tabHeading.ariaSelected = 'true'
        tabHeading.classList.add('active')
      } else {
        tabHeading.tabIndex = -1
      }

      tabTitle.className = 'pbc-title'
      tabTitle.innerHTML = tab.title

      tabHeading.appendChild(tabTitle)
      tabHeadings.appendChild(tabHeading)
    })

    tabData.tabs?.forEach((tab, index) => {
      let tabContent = document.createElement('div');

      tabContent.className = 'pbc-tab-content'
      tabContent.id = 'tab-panel-' + index
      tabContent.role = 'tabpanel'
      tabContent.tabIndex = 0
      tabContent.setAttribute('aria-labelledby', 'tab-trigger-' + index)

      if (index === 0) {
        tabContent.classList.add('active')
      }

      if (tabData.tabType?.value === 'description') {
        tabContent.innerHTML = tab.contentText;
      } else {
        if (tab.contentType?.value === 'text') {
          tabContent.innerHTML = tab.contentText;
        } else if (tab.contentType?.value === 'html') {
          tabContent.innerHTML = tab.html;
        } else if (tab.contentType?.value === 'image') {
          let tabImage = document.createElement('img')

          tabImage.src = tab.contentImage.url
          tabImage.width = tab.contentImage.width
          tabImage.alt = "Image of " + (tab.orderPosition + 1) + " tab"

          tabContent.appendChild(tabImage)
        } else if (tab.contentType?.value === 'productDescription') {
          tabContent.innerHTML = document.getElementById('pbc-description').innerHTML
        } else if (tab.contentType?.value === 'metafield') {
          tabContent.innerHTML = tab.metafieldValue ? window.pbcTabWidget.renderMetafieldValue(tab.metafieldType, tab.metafieldValue) : ''
        } else {
          let videoContainer = document.createElement('div');
          videoContainer.className = 'pbc-video-container';

          if (tab.contentVideo.includes('cdn.shopify.com') || tab.contentVideo.includes('shopify')) {
            let videoElement = document.createElement('video');
            videoElement.src = window.pbcTabWidget.extractVideoUrl(tab.contentVideo);
            videoElement.controls = true;
            videoElement.width = '100%';
            videoContainer.appendChild(videoElement);
          } else {
            let iframe = document.createElement('iframe');
            iframe.src = window.pbcTabWidget.extractVideoUrl(tab.contentVideo);
            iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope;';
            iframe.allowFullscreen = true;
            videoContainer.appendChild(iframe);
          }

          tabContent.appendChild(videoContainer);
        }
      }

      tabContents.appendChild(tabContent)
    })

    wrapper.appendChild(tabHeadings)
    wrapper.appendChild(tabContents)
  },
  renderRegularDescription: (wrapper) => {
    wrapper.innerHTML = document.getElementById('pbc-description').textContent
  },
  renderAccordions: (tabData, wrapper) => {
    tabData.tabs?.forEach((tab, index) => {
      let accordion = document.createElement('div');
      let heading = document.createElement('h3');
      let accordionHeading = document.createElement('button');
      let accordionTitle = document.createElement('span');
      let accordionIcon = document.createElement('div');
      let accordionContent = document.createElement('section');

      accordion.className = 'pbc-accordion';

      accordionHeading.className = 'pbc-accordion-heading';
      accordionHeading.id = 'accordion-trigger-' + index;
      accordionHeading.type = 'button';
      accordionHeading.setAttribute('aria-expanded', 'false')
      accordionHeading.setAttribute('aria-controls', 'accordion-panel-' + index)

      accordionTitle.className = 'pbc-title';
      accordionTitle.innerHTML = tab.title;

      accordionIcon.className = 'pbc-icon';
      accordionContent.className = 'pbc-accordion-content';
      accordionContent.classList.add('pbc-content')
      accordionContent.id = 'accordion-panel-' + index;
      accordionContent.setAttribute('aria-labelledby', 'accordion-trigger-' + index)

      if (tabData.openBehavior?.value === 'allOpened' || (tabData.openBehavior?.value === 'firstOpened' && index === 0)) {
        accordionHeading.setAttribute('aria-expanded', 'true')
        accordionContent.classList.add('expanded')
        tabData.iconType?.value === 'plus' ? accordionIcon.innerHTML = iconMinus : accordionIcon.innerHTML = chevronUp
        accordionContent.hidden = false
      } else {
        accordionHeading.setAttribute('aria-expanded', 'false')
        tabData.iconType?.value === 'plus' ? accordionIcon.innerHTML = iconPlus : accordionIcon.innerHTML = chevronDown
        accordionContent.hidden = true
      }

      if (tabData.tabType?.value === 'description') {
        accordionContent.innerHTML = tab.contentText;
      } else {
        if (tab.contentType?.value === 'text') {
          accordionContent.innerHTML = tab.contentText;
        } else if (tab.contentType?.value === 'html') {
          accordionContent.innerHTML = tab.html;
        } else if (tab.contentType?.value === 'image') {
          let accordionImage = document.createElement('img')

          accordionImage.src = tab.contentImage.url
          accordionImage.width = tab.contentImage.width
          accordionImage.alt = "Image of " + (tab.orderPosition + 1) + " tab"

          accordionContent.appendChild(accordionImage)
        } else if (tab.contentType?.value === 'productDescription') {
          accordionContent.innerHTML = document.getElementById('pbc-description').innerHTML
        } else if (tab.contentType?.value === 'metafield') {
          accordionContent.innerHTML = tab.metafieldValue ? window.pbcTabWidget.renderMetafieldValue(tab.metafieldType, tab.metafieldValue) : ''
        } else {
          let videoContainer = document.createElement('div');
          videoContainer.className = 'pbc-video-container';

          if (tab.contentVideo.includes('cdn.shopify.com') || tab.contentVideo.includes('shopify')) {
            let videoElement = document.createElement('video');
            videoElement.src = window.pbcTabWidget.extractVideoUrl(tab.contentVideo);
            videoElement.controls = true;
            videoElement.width = '100%';
            videoContainer.appendChild(videoElement);
          } else {
            let iframe = document.createElement('iframe');
            iframe.src = window.pbcTabWidget.extractVideoUrl(tab.contentVideo);
            iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope;';
            iframe.allowFullscreen = true;
            videoContainer.appendChild(iframe);
          }

          accordionContent.appendChild(videoContainer);
        }
      }

      accordionHeading.appendChild(accordionTitle);
      accordionHeading.appendChild(accordionIcon);
      heading.appendChild(accordionHeading);
      accordion.appendChild(heading);
      accordion.appendChild(accordionContent);
      wrapper.appendChild(accordion);
    })
  },
  initAccordionListeners: (iconType, wrapper) => {
    let accordionTriggers = wrapper.querySelectorAll('button.pbc-accordion-heading');

    accordionTriggers.forEach(trigger => {
      trigger.addEventListener('click', function() {
        if (this.getAttribute('aria-expanded') === 'true') {
          this.setAttribute('aria-expanded', 'false')
          this.closest('.pbc-accordion').querySelector('.pbc-accordion-content').classList.remove('expanded');
          this.closest('.pbc-accordion').querySelector('.pbc-accordion-content').hidden = true;

          iconType === 'plus' ? this.querySelector('.pbc-icon').innerHTML = iconPlus : this.querySelector('.pbc-icon').innerHTML = chevronDown
        } else {
          this.setAttribute('aria-expanded', 'true')
          this.closest('.pbc-accordion').querySelector('.pbc-accordion-content').classList.add('expanded');
          this.closest('.pbc-accordion').querySelector('.pbc-accordion-content').hidden = false;

          iconType === 'plus' ? this.querySelector('.pbc-icon').innerHTML = iconMinus : this.querySelector('.pbc-icon').innerHTML = chevronUp
        }
      })
    })
  },
  initTabListeners: (wrapper) => {
    const tabHeadings = Array.from(wrapper.querySelectorAll('.pbc-tab-heading'));
    const tabContents = Array.from(wrapper.querySelectorAll('.pbc-tab-content'));

    const firstTab = tabHeadings[0]
    const lastTab = tabHeadings[tabHeadings.length - 1]

    tabHeadings.forEach((heading) => {
      heading.addEventListener('click', function() {
        return setActiveTab(heading)
      })

      heading.addEventListener('keydown', function(evt) {
        let currentTab = evt.currentTarget

        switch (evt.key) {
          case 'ArrowLeft':
            selectPreviousTab(currentTab)
            break;

          case 'ArrowRight':
            selectNextTab(currentTab)
            break;

          case 'Home':
            setActiveTab(firstTab)
            break;

          case 'End':
            setActiveTab(lastTab)
            break;

          default:
            break;
        }
        evt.stopPropagation();
        evt.preventDefault();
      })
    })

    function setActiveTab(trigger) {
      const triggerIndex = tabHeadings.indexOf(trigger)

      if (trigger.classList.contains('active')) return;

      tabContents.forEach((content, contentIndex) => {
        content.classList.remove('active')

        if (triggerIndex === contentIndex) {
          content.classList.add('active')
        }
      })

      tabHeadings.forEach(item => {
        item.classList.remove('active')
        item.setAttribute('aria-selected', 'false')
        item.setAttribute('tabindex', '-1')
      })

      trigger.classList.add('active')
      trigger.setAttribute('aria-selected', 'true')
      trigger.focus()
      trigger.removeAttribute('tabindex')
    }

    function selectNextTab(currentTab) {
      let nextIndex;

      if (currentTab === lastTab) {
        setActiveTab(firstTab);
      } else {
        nextIndex = tabHeadings.indexOf(currentTab) + 1;
        setActiveTab(tabHeadings[nextIndex]);
      }
    }

    function selectPreviousTab(currentTab) {
      let previousIndex;

      if (currentTab === firstTab) {
        setActiveTab(lastTab);
      } else {
        previousIndex = tabHeadings.indexOf(currentTab) - 1;
        setActiveTab(tabHeadings[previousIndex]);
      }
    }
  }
}

let tabWidgets = document.querySelectorAll('.pbc-tab-widget');

if (tabWidgets.length > 0) {
  for (let i = 0; i < tabWidgets.length; i++) {
    let productId = tabWidgets[i].dataset.productId
    tabs.push({
      productId: productId,
      wrapper: tabWidgets[i],
      config: {}
    })
  }
  window.pbcTabWidget.init();
}
